import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { LIVE_LINK } from '../helpers/url_helper';

export const pricesApi = createApi({
  reducerPath: 'pricesApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${LIVE_LINK}/prices` }),
  tagTypes: ['products'],
  endpoints: (build) => ({
    fetchAllPrices: build.query({
      query: () => {
        return {
          url: '/'
        };
      }
    }),
    getFont: build.mutation({
      query: (fontData) => {
        return {
          url: '/font',
          method: 'POST',
          body: fontData
        };
      }
    }),
    addPrice: build.mutation({
      query: (newRow) => ({
        url: '/',
        method: 'POST',
        body: newRow
      }),
      async onQueryStarted(newRow, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        let patchResult = '';
        if (data) {
          patchResult = dispatch(
            pricesApi.util.updateQueryData('fetchAllPrices', undefined, (draft) => {
              const formattedRow = { ...newRow, _id: data._id };
              draft.products.push(formattedRow);
            })
          );
        }
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic deletion on failure
        }
      }
    }),
    updatePrice: build.mutation({
      query: (updatedRow) => ({
        url: `/${updatedRow._id}`,
        method: 'PUT',
        body: updatedRow
      }),
      async onQueryStarted(updatedRow, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        let patchResult = '';
        if (data) {
          patchResult = dispatch(
            pricesApi.util.updateQueryData('fetchAllPrices', undefined, (draft) => {
              const item = draft.products.find((row) => row._id === updatedRow._id);
              if (item) {
                Object.assign(item, updatedRow);
              }
            })
          );
        }
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic deletion on failure
        }
      }
    }),
    trackPdfDownload: build.mutation({
      query: (data) => ({
        url: '/pdf-download',
        method: 'POST',
        body: data
      })
    }),
    deletePrice: build.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: 'DELETE'
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          pricesApi.util.updateQueryData('fetchAllPrices', undefined, (draft) => {
            const index = draft.products.findIndex((row) => row._id === id);
            if (index !== -1) {
              draft.products.splice(index, 1);
            }
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic deletion on failure
        }
      }
    })
  })
});
